export default __webpack_public_path__ + "static/media/investors_logo15.1ad63a03.png";